import { FormsService } from "../../../services/forms/forms.service";
import { DisconnectPaymentMethodActionType, PaymentMethodEnum } from "../types";

export function* disconnectPaymentSaga({ payload }: DisconnectPaymentMethodActionType) {
    try {
        yield FormsService.disconnectPaymentMethod(payload);

        switch (payload.type) {
            case PaymentMethodEnum.PAYPAL:
                window.handleChange({ id: "payment.paymentMethod.paypal", value: false });
                break;
            case PaymentMethodEnum.STRIPE:
                window.handleChange({ id: "payment.paymentMethod.stripe", value: false });
                break;
            case PaymentMethodEnum.CASH:
                window.handleChange({ id: "payment.paymentMethod.cash", value: false });
                break;
        }
    } catch (error) {
        console.log("Disconnect error", error);
        // yield put(Handle Error);
    }
}
